/**
 * Matches a Workspace gateway (document-store) request URL. Shared by every interceptor that
 * has to recognise gateway traffic, so they cannot drift apart.
 *
 * The gateway mounts every route under `/api`, so these are matched by their top-level
 * segment. `@semeris/workspace-ui`'s clients build all of theirs from `injectApiRoot()` and
 * reach seven — `workspaces` (including the bare collection), `libraries`, `datasets`, `db`,
 * `grants`, `principals` and `me` (the AI tech-preview notice gate) — plus `admin`, which the
 * host reaches directly for the chat tool-call inspector. Both URL forms are covered:
 * same-origin `/api/…` when deployed, and absolute `https://workspace-dev.semeris.com/api/…`
 * locally.
 *
 * Widen this the moment a new package surface is wired: an unlisted segment doesn't error, it
 * 401s and renders as an empty screen. That has already cost three debugging rounds. It also
 * loses the impersonation header, which shows the admin's data with no error at all.
 */
// Adding a segment sdocs' own backend also serves under `/api` would divert that traffic
// here — sdocs mounts at `…/sdocs/api/*`, which these eight do not collide with. The trailing
// boundary group is what keeps `me` off sdocs' own `/api/memo/…`.
export const WORKSPACE_GATEWAY_URL = /\/api\/(?:workspaces|libraries|datasets|db|grants|principals|me|admin)(?:[/?#]|$)/;
